module.exports = __webpack_public_path__ + "img/res4.14b329a8.gif";